import { render, staticRenderFns } from "./ManPosition.vue?vue&type=template&id=675ca9cc&scoped=true"
import script from "./ManPosition.vue?vue&type=script&lang=js"
export * from "./ManPosition.vue?vue&type=script&lang=js"
import style0 from "./ManPosition.vue?vue&type=style&index=0&id=675ca9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675ca9cc",
  null
  
)

export default component.exports